import { useState, useEffect, useRef, Fragment } from 'react';
import { formatNumber } from 'src/utils/utils';
import "./index.scss";

export const useChartTooltip = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipContent, setTooltipContent] = useState<React.ReactNode>(null);;
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef(null);

  const handleChartClick = (params, timeSpentResponse) => {
    const { dataIndex, event } = params;
    if (timeSpentResponse) {
      const visitData = timeSpentResponse?.tb_by_visit?.find((visit) => visit.visit_index === dataIndex);
      if (visitData) {
        const activityCount = visitData.activities_list.length;
        const formattedActivities = (
            <div className="tooltip-activities-container">
              <p className="tooltip-activities-title">
                  Related Activities: {activityCount}
              </p>

              {visitData.activities_list.map((activity, index) => (
                <Fragment key={index}>
                  <span >
                    - {activity.std_activity} 
                    <span className="tooltip-patient-time">
                      ({formatNumber(activity?.activity_patient_time)} mins)
                    </span>
                  </span>
                  <br />
                </Fragment>
              ))}
            </div>
          );
        const tooltipX = event.event.offsetX;
        const tooltipY = event.event.offsetY;
        setTooltipContent(formattedActivities);
        setTooltipPosition({ x: tooltipX, y: tooltipY });
        setTooltipVisible(true);
      }
    }
  };

  return {
    tooltipVisible,
    setTooltipVisible,
    tooltipContent,
    setTooltipContent,
    tooltipPosition,
    setTooltipPosition,
    tooltipRef,
    handleChartClick, 
  };
};
